<template>
	<div class="goods">
		<v-head :title="title"></v-head>
			<ul id="normaltab1" class="tabbtn">
				<li :class="{'current': isSelect === 0}" @click="isSelect = 0">
					<a>全部风采</a>
				</li>
				<li :class="{'current': isSelect === 1}" @click="isSelect = 1">
					<a>个人风采</a>
				</li>
			</ul>
			<div class="list">
				<div class="warmTip" v-if="list.content && list.content.length<1">
					<img src="../../assets/images/404.png"/>
					<span>没有找到相应内容哦</span>
				</div>
				<ul class="meeting_box">
					<li v-for="(item,index) in list.content" :key="index" >
						<div class="fonts" @click="goDetail(item.id)">
							<h4>{{item.title}}</h4>
							<div class="status">
								<span>发布人：{{item.name}}</span>
								<span>审核结果：{{stateFormat(item.status)}}</span>
							</div>
							<p>{{intercept(item.content)}}</p>						
						</div>
					</li>
				</ul>
			</div>
	</div>
</template>

<script>
import {Button,Toast } from 'vant';
import vHead from "../../components/Subhead.vue";
import {getMemberStyleList,getCurrentAccount} from "@/api/dictionary";
import {getSessionStore} from "@/utils/sessionStorage.js"
export default {
  data() {
    return {
		list:[],
		item:{},
		isSelect:0,
		member:{},
		page:1,
		title:"",
		params:{
			name:null,
			title:null,
			content:"",
			userId:"",
			status:1
		}
    };
  },
  filters: {
    
  },
  components: {
	  vHead,
	  [Button.name]: Button,
	  [Toast.name]: Toast,
  },
  methods: {
	  getData() {

		  if(this.isSelect==1){
			  this.params.userId = getSessionStore("userId");
			  delete(this.params.status);
		  }else {
			  this.params.status =1;
			  this.params.userId = "";
		  }
		  getMemberStyleList(this.params, this.page-1)
				  .then(res => {
					  if (res.success) {
						  this.list = res.result;
					  }
				  })
				  .catch(() => {
					  Toast.fail("获取数据失败");
				  });
	  },
	  intercept(item){
		let reg = new RegExp(/<[^>]+>/g);
     	if(item){
            let content = item.replace(reg,"");
            return content;
        } 
	  },
	  stateFormat(status){
         if (status == 1) {
            return '审核通过'
          } else if (status == 2) {
            return '审核不通过'
          } else if (status == 4) {
            return '待审核'
          }
	  },
	  getMember() {
		  const me = this;
		  let token = getSessionStore("access_token");
		  if (token) {
			  getCurrentAccount({
				  access_token: token
			  })
					  .then(resp => {
						  me.member = resp.result;
						  if (me.member.memberStatus == 1) {
							  $(".noMember").css("display","none");
						  } else {
							  $(".noMember").css("display","block");
							  $(".member").css("display","none");
							  $(".addbottom").css("display","none")
						  }
					  })
					  .catch(err => {});
		  }
	  },
	  goDetail(id){
	  	this.$router.push({name:"memberStyleDetail",query:{"id":id}});
	  }
  },
  computed: {
    
  },
	watch:{
		isSelect(){
			this.getData();
		}
	},
  mounted() {
	  //获取到用户信息  判断他的状态 如果不是正式会员 跳转页面  或者弹出提示 遮罩
	  this.getMember();
	  this.getData();
  }

}
</script>
<style lang="less" scoped>
	.tabbtn{ width:75%; display: block; overflow: hidden; position: absolute; top: 0; right: 0; z-index: 999;}
	.tabbtn li{ text-align: center; font-size:15px;float: left;  padding:25px 0 15px 0;
	margin: 0 20px;}
	.tabbtn li.current{  border-bottom: #378be1 solid 2px; }
	.tabbtn li.current a{color: #378be1;}
	.list{ padding: 0 14px;}
	.list li{ padding:15px 0; border-bottom: #efefef solid 1px; margin-bottom: -1px;color: #000;}
	.list li .status{ margin: 10px 0;}
	.list li span{ font-size:12px; color: #666; margin-right: 15px;}
	.list li p{ display: -webkit-box;
    -webkit-line-clamp:2;
    overflow: hidden;
    text-overflow: ellipsis;
	-webkit-box-orient: vertical;color: #333; font-size:14px; line-height: 24px;}

</style>